import { useState } from "react";
import Container from "./Container";
import ProfileSidebar from "./ProfileSidebar";
import ProfileSettings from "./ProfileSettings";
import AccountBalance from "./AccountBalance";

export default function AccountSettings() {
  const [activeTab, setActiveTab] = useState("Profile Settings");

  return (
    <section className="flex min-h-screen items-start justify-center bg-white py-12">
      <Container>
        <div className="flex w-full flex-col md:flex-row gap-6">
          <ProfileSidebar activeTab={activeTab} setActiveTab={setActiveTab} />

          {/* Content */}
          <div className="flex-1">
            {activeTab === "Profile Settings" ? (
              <ProfileSettings />
            ) : (
              <AccountBalance />
            )}
          </div>
        </div>
      </Container>
    </section>
  );
}
